import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeliveryTopTemplate, TopTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getTopTab } from 'reducks/auth/selectors'

const Top: FC = () => {
  const topTab = useSelector((state: State) => getTopTab(state))
  const Template = () => {
    if (topTab === 'hand_over') {
      return <TopTemplate />
    } else {
      return <DeliveryTopTemplate />
    }
  }
  return <Layout title={'トップページ'}>{Template()}</Layout>
}

export default Top
